import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoRounds = props => {
  switch (props.type) {
    case "apply":
      return /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center justify-center h-full mt-4 mb-10",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-grey-400 text-sm",
          children: "No rounds are currently accepting applications."
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-grey-400 text-sm mt-2",
          children: ["Stay tuned on", " ", /*#__PURE__*/_jsx("a", {
            className: "text-violet-400",
            href: "https://twitter.com/gitcoin",
            target: "_blank",
            children: "Gitcoin Twitter"
          }), " ", "for the latest news and updates!"]
        })]
      });
    case "active":
      return /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center justify-center h-full mt-4 mb-10",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-grey-400 text-sm",
          children: "No rounds are currently ongoing."
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-grey-400 text-sm mt-2",
          children: ["Stay tuned on", " ", /*#__PURE__*/_jsx("a", {
            className: "text-violet-400",
            href: "https://twitter.com/gitcoin",
            target: "_blank",
            children: "Gitcoin Twitter"
          }), " ", "for the latest news and updates!"]
        })]
      });
  }
};
export default NoRounds;